import Model from './Model';
import { emptyModal, minToHoursMin } from './Helpers';

let modalBodyHtml = require('../../src/templates/modalBody.html');
let ModalWindow = {
  openDetailModal(kId) {
    // console.log('modalBodyHtml:', JSON.stringify(modalBodyHtml, null, '\t'));
    let data = Model.data[kId];
    console.log('data:', JSON.stringify(data, null, '\t'));
    emptyModal();
    let modalTitleDiv = $('#modalTitle');
    let modalBodyDiv = $('.modal-body');
    //set titles
    modalTitleDiv.html(
      '<div class="modalHeader1">' +
        data.kursus_kategori +
        '</div><div class="modalHeader2">' +
        data.kTitel +
        '</div>'
    );

    modalBodyDiv.html(modalBodyHtml);
    modalBodyDiv.find('#eTid').html(minToHoursMin(data.eTid));
    modalBodyDiv.find('#fTid').html(minToHoursMin(data.fTid));
    modalBodyDiv.find('#skills').html(data.maalgruppe_beskrivelse);

    $('#contentModal').modal();
    $('.modalBtn')
      .attr({
        'data-pid': data.pId,
        'data-kid': data.kId,
      })
      .click(function() {
        console.log('modalBtn click');
        let target = $(this);
        let param = {
          task: target.attr('data-task'),
          pid: target.attr('data-pid'),
          kid: target.attr('data-kid'),
          type: target.attr('data-type'),
        };

        modalBtnOnClick(target, param);
      });
  },
};

let modalBtnOnClick = function(target, param) {
  console.log('function: "modalBtnOnClick()" called:');
  console.log('param:', JSON.stringify(param, null, '\t'));
  switch (param.task) {
    case 'openCourse':
      window.open(
        Model.urls.player +
          '?p=' +
          param.pid +
          '&t=' +
          param.type +
          '&k=' +
          param.kid
      );
      break;
    case 'copyLink': {
      console.log('%ccopyLink:', 'color:orange;');

      let input = $('<input>', {
        type: 'text',
        value:
          Model.urls.player +
          '?p=' +
          param.pid +
          '&t=' +
          param.type +
          '&k=' +
          param.kid,
      })
        .appendTo($('.modal-body'))
        .select();
      document.execCommand('copy');
      input.remove();
      $('.modalBtn').popover('hide');
      target
        .popover({
          trigger: 'click',
          content: 'Linket er kopieret til udklipsholderen',
          placement: 'top',
        })
        .popover('show');
      setTimeout(function() {
        $('.modalBtn').popover('hide');
      }, 3000);
      break;
    }

    case 'openEditor':
      console.log('%copenEditor:', 'color:orange;');
      document.location.assign(
        Model.urls.edit + '?pid=' + param.pid + '&kid=' + param.kid
      );
      break;
  }
};
export default ModalWindow;
